import moment from 'moment'
import React from 'react'

interface IAppDashboardHeaderProps {
  activatedAt: string
  userName: string
}

export const AppDashboardHeader: React.FC<IAppDashboardHeaderProps> = ({
  activatedAt,
  userName,
}) => {
  const isActivatedToday = moment().isSame(moment(activatedAt), 'day')
  return (
    <div className="space-y-2 mt-4 lg:mt-0">
      <h3 className="font-medium text-2xl font-inter">{`${
        isActivatedToday ? 'Hi,' : 'Welcome Back,'
      } ${userName}!`}</h3>
      <p className="font-normal font-inter text-sm text-app-grey-70">
        Here is what has happened recently
      </p>
    </div>
  )
}
